<template>
  <div class="template">

    <p>
      <a href="https://litteraturbanken.se/forfattare/Anonym/titlar/ProtocollerHogsteDomstol/sida/1/faksimil" target="_blank">
        Rättegångsprotokoll rörande mordet på Gustaf III
      </a>
    </p>

    <p>
      <a href="https://litteraturbanken.se/forfattare/AlmqvistCJL/titlar/SamladeVerk6/sida/145/etext" target="_blank">
        Anckarströms bekännelse i Drottningens juvelsmycke
      </a>
    </p>

  </div>
</template>

<script>
export default {
  name: 'DJSources',
  readable: 'Källor',
  route: 'kallor',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.border{
  border: 1px solid gray;
}

</style>



// WEBPACK FOOTER //
// src/components/objects/drottningensjuvelsmycke/tabs/DJSources.vue